import { render, staticRenderFns } from "./file_manager.vue?vue&type=template&id=0a604d26&scoped=true"
import script from "./file_manager.vue?vue&type=script&lang=js"
export * from "./file_manager.vue?vue&type=script&lang=js"
import style0 from "./file_manager.vue?vue&type=style&index=0&id=0a604d26&prod&lang=css"
import style1 from "./file_manager.vue?vue&type=style&index=1&id=0a604d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a604d26",
  null
  
)

export default component.exports